<template>
  <span 
    :class="[
      'text-capitalize', 
      'badge', 
      'bg-light', 
      'border', 
      'rounded-pill',
      statusColor
    ]">{{ status }}</span>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  computed: {
    statusColor() {
      const colors = {
        pending: 'text-info',
        dispatched: 'text-primary',
        delivered: 'text-success'
      };
      return colors[this.status] || '';
    }
  }
};
</script>
